module.exports = __webpack_public_path__ + "img/banner02_info_S_3.45e08948.png";